module.exports = __webpack_public_path__ + "static/media/cookie.2edf36c4.svg";